/* eslint-disable */
import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(theme => ({
  qrcode: {
    // height: 'calc(100vh - 200px)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    color: theme.palette.text.primary,
  },
}));
